"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading = function Heading(_ref) {
  var children = _ref.children,
      truncated = _ref.truncated;
  var headingStyles = ['co-header__heading', 'co-heading'];
  return _react.default.createElement(_styler.default, {
    classNames: headingStyles,
    modifiers: {
      truncated: truncated
    }
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

Heading.propTypes = {
  /** {---} Sequence of:
   * @@<Header.PreTitle>@@ (optional, max: 1),
   * @@<Image>@@ or @@<Header.Title>@@ (required, max: 1),
   * @@<Header.Description>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,
  truncated: _propTypes.bool
};
Heading.displayName = 'Header.Heading';
var _default = Heading;
exports.default = _default;
Heading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Header.Heading",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of:\n@@<Header.PreTitle>@@ (optional, max: 1),\n@@<Image>@@ or @@<Header.Title>@@ (required, max: 1),\n@@<Header.Description>@@ (optional, max: 1)"
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};